import { Injectable } from '@angular/core';
import { ClientParentDetails } from '@client-parents/models/client-parent-details';
import { Details } from '../../details/Interfaces/details';
import { LayoutOrientation } from '../../common/enums/layout-orientation';
import { has, DetailsBuilder } from '@details/Interfaces/details-builder';
import { nameOnly, simple, anchor } from '@details/Interfaces/details-item-types';
import { DataFormatter } from '@common/services/data-formatter.service';
import { as } from '@common/string-formatter/string-formatter';

@Injectable({
  providedIn: 'root'
})
export class ClientParentDetailsMapperService {

  constructor(
    private readonly dataFormatter: DataFormatter
  ) { }

  mapToDetails(details: ClientParentDetails): Details {

    const showCompanySection = has(details.VatReg, details.RegisteredCompanyNumber);

    const showContactSection = has(details.ContactName, details.Phone, details.DirectPhone, details.MobilePhone, details.Email, details.Fax);

    const showNrlSection = has(details.ContactName);

    const b = new DetailsBuilder(`Reference ${details.Ref}`, details);

    b.section('Client Parent', LayoutOrientation.Vertical)
      .always(nameOnly(details.Name))
      .for('StrungAddress', 'Address:');

    b.conditionalSection(showCompanySection, null, LayoutOrientation.Horizontal)
      .for('VatReg', 'Vat registration:')
      .for('RegisteredCompanyNumber', 'Registered Company No:');

    b.conditionalSection(showContactSection, 'Contact', LayoutOrientation.Horizontal)
      .for('ContactName', 'Name:')
      .telFor('Phone', 'Phone:')
      .telFor('DirectPhone', 'Direct phone:')
      .telFor('MobilePhone', 'Mobile phone:')
      .mailFor('Email', 'Email:')
      .for('Fax', 'Fax:');

    b.conditionalSection(showNrlSection, '', LayoutOrientation.Horizontal)
      .for('FicoRegNumber', 'NRL registration no:')
      .for('FicoStatus', 'NRL status:')
      .conditionalItem(details.FicoApprovalDate != undefined,
        simple('NRL approval date:', this.dataFormatter.formatDate(details.FicoApprovalDate)));

    return b.getDetails();

  }

}
